<div class="mode animated backOutRight" [ngbTooltip]="diplayMode() | translate">
  <svg-icon src="assets/svgIcon/lightmood.svg"></svg-icon>  
  <svg-icon  src="assets/svgIcon/darkmood.svg"></svg-icon>  
</div>
<!-- [ngbTooltip]="'settings.darkMode.title' | translate" -->